import type { AnchorHTMLAttributes, MouseEvent, ReactNode } from 'react';
import { trackRegisterClick } from '@/lib/analytics';

type RegisterLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  section: string;
  linkLabel?: string;
  children: ReactNode;
};

export default function RegisterLink({
  section,
  linkLabel,
  onClick,
  children,
  ...props
}: RegisterLinkProps) {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    trackRegisterClick({ section, linkLabel });
    onClick?.(event);
  };

  return (
    <a {...props} onClick={handleClick}>
      {children}
    </a>
  );
}
